module.exports = __webpack_public_path__ + "static/img/email_img.9dbc8fb5.svg";